import { useCallback, useSyncExternalStore } from 'react';

/**
 * Observes window scroll and returns true when the page is scrolled past
 * `threshold` pixels. Used by Navbar to toggle transparent/solid states.
 *
 * Uses useSyncExternalStore with a passive scroll listener. The boolean is
 * stable across re-renders while the scroll position stays on the same side
 * of `threshold`, so consumers don't re-render on every pixel.
 */
export function useScrollPosition(threshold = 40): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    window.addEventListener('scroll', onChange, { passive: true });
    return () => window.removeEventListener('scroll', onChange);
  }, []);

  const getSnapshot = useCallback(
    () => window.scrollY > threshold,
    [threshold]
  );

  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
